export enum ElevatorAnimationType {
    CLOSING_DOOR = 'closingDoor',
    OPENING_DOOR = 'openingDoor',
    MOVING_UP = 'movingUp',
    MOVING_DOWN = 'movingDown',
}
